import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RefreshCw, X } from 'lucide-react';
import { Button } from '../ui/button';
import { formatDate, saTodayISO } from '../../lib/dateUtils';
import { useAuth } from '../../context/AuthContext';


export const RenewalBanner = ({ status }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const HIDE_KEY = `ny-renew-banner-hidden-${user?.user_id}`;
  const [hidden, setHidden] = useState(localStorage.getItem(HIDE_KEY) === saTodayISO());
  const due = status.vehicles.filter((v) => v.plan_active && v.plan_days_left <= 30 && v.pending_payments === 0);
  if (hidden || due.length === 0) return null;

  const soonest = due.reduce((a, b) => (a.plan_days_left <= b.plan_days_left ? a : b));
  const regs = due.map((v) => v.registration_number).join(', ');
  const hide = () => { localStorage.setItem(HIDE_KEY, saTodayISO()); setHidden(true); };

  return (
    <div className="mb-4 rounded-2xl border border-amber-300 bg-gradient-to-r from-amber-50 to-white p-4 flex flex-col sm:flex-row sm:items-center gap-3 justify-between" data-testid="renewal-banner">
      <div className="flex items-start gap-3">
        <span className="w-10 h-10 rounded-xl bg-amber-400 text-emerald-950 flex items-center justify-center shrink-0"><RefreshCw className="w-5 h-5" /></span>
        <div>
          <p className="font-heading font-bold text-amber-950">Renew now and keep tracking</p>
          <p className="text-sm text-amber-900" data-testid="renewal-banner-text">
            Your Finance Tracker for {regs} ends {soonest.plan_days_left <= 1 ? 'tomorrow' : `in ${soonest.plan_days_left} days`} ({formatDate(soonest.plan_expires_at)}). One EFT of R199 per vehicle adds another 12 months — no days lost.
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2 self-end sm:self-auto">
        <Button onClick={() => navigate('/finance?pay=renew')} className="rounded-full bg-emerald-900 hover:bg-emerald-800" data-testid="renewal-banner-renew-btn">Renew now</Button>
        <Button variant="ghost" size="icon" onClick={hide} aria-label="Hide until tomorrow" data-testid="renewal-banner-hide-btn"><X className="w-4 h-4" /></Button>
      </div>
    </div>
  );
};
